const setLibPhoneNumberMetaData = () => {
	if (
		sessionStorage.getItem('json_called') === 'true' ||
		(sessionStorage.getItem('mobile_min_json') &&
			sessionStorage.getItem('min_json'))
	) {
		return
	}

	sessionStorage.setItem('json_called', 'true')

	const headers = new Headers({
		'Content-Type': 'application/json',
	})
	const requestDetails = {
		method: 'GET',
		headers,
	}
	const META_DATA_URLS = [
		'https://s3.ap-south-1.amazonaws.com/oceanjar-new/images/web_app/metadata.custommobile.json',
		'https://s3.ap-south-1.amazonaws.com/oceanjar-new/images/web_app/metadata.custommin.json',
	]

	META_DATA_URLS.forEach((url, index) => {
		fetch(url, requestDetails)
			.then(response => {
				if (!response.ok) {
					sessionStorage.setItem('json_called', 'false')
					throw new Error('---HTTP error---' + response.status)
				}
				return response.json()
			})
			.then(json => {
				sessionStorage.setItem(
					`${index === 0 ? 'mobile_' : ''}min_json`,
					JSON.stringify(json),
				)
			})
			.catch(error => {
				// console.log('----error-----', error);
				sessionStorage.setItem('json_called', 'false')
				return error
			})
	})
}
export default setLibPhoneNumberMetaData
